import type { ComponentType, SVGProps } from 'react';
import styled, { css } from 'styled-components';

import ChatSVG from '@/assets/icons/chat.svg';
import CloseSVG from '@/assets/icons/close.svg';
import FavouritesSVG from '@/assets/icons/favorites.svg';
import FavouritesFilledSVG from '@/assets/icons/favorites-filled.svg';
import HomeSVG from '@/assets/icons/home.svg';
import MenuDotsSVG from '@/assets/icons/menu-dots.svg';
import PhoneSVG from '@/assets/icons/phone.svg';
import PlusSVG from '@/assets/icons/plus.svg';
import DefaultUserSVG from '@/assets/icons/profile-user.svg';
import { Project } from '@/types/project';

export interface IconProps {
  $isActive: boolean;
  $project?: Project;
  $filled?: boolean;
  $color?: string;
  $width?: number;
}

const iconStyles = css<IconProps>`
  stroke: ${({ theme, $isActive, $project, $filled = false, $color }) => {
    if ($filled) return theme.bg.main;

    if ($isActive && $project) return $project.brandColor;

    return $color ?? theme.text.main;
  }};

  fill: ${({ theme, $isActive, $project, $filled = false, $color }) => {
    if (!$filled) return 'none';

    if ($isActive && $project) return $project.brandColor;

    return $color ?? theme.text.main;
  }};

  ${({ $width }) => $width && `width: ${$width}px;`}
`;

type SVGComponent = ComponentType<SVGProps<SVGSVGElement>>;

const createIcon = (Svg: SVGComponent) => styled(Svg)<IconProps>`
  ${iconStyles}
`;

export const HomeIcon = createIcon(HomeSVG);
export const ChatIcon = createIcon(ChatSVG);
export const FavouritesIcon = createIcon(FavouritesSVG);
export const FavouritesFilledIcon = createIcon(FavouritesFilledSVG);
export const DefaultUserIcon = createIcon(DefaultUserSVG);

export const PlusIcon = styled(PlusSVG)<
  Pick<IconProps, '$isActive' | '$project'>
>`
  stroke: ${({ $isActive, $project, theme }) =>
    $isActive && $project ? $project.brandColor : theme.text.main};
`;

export const MenuDotsIcon = styled(MenuDotsSVG)`
  fill: ${({ theme }) => theme.text.main};
`;

export const CloseIcon = styled(CloseSVG)`
  fill: ${({ theme }) => theme.text.tertiary};
`;

export const PhoneIcon = styled(PhoneSVG)`
  display: block;
  fill: currentColor;
`;
